import firebase from "firebase/app";
import "firebase/firestore";
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyDLXIcd97IpdMxOJjbydi9D-X8M48RWEjM",
    authDomain: "life-long-poly.firebaseapp.com",
    projectId: "life-long-poly",
    storageBucket: "life-long-poly.appspot.com",
    messagingSenderId: "375897987091",
    appId: "1:375897987091:web:779560abb140f3c85a47e6"
  };

firebase.initializeApp(firebaseConfig);
firebase.firestore();
firebase.storage();

export default firebase;
